import React, { useState, useEffect, useRef } from "react";

const ImageWithSkeleton = ({
    src,
    alt = "",
    height = "500px",
    className = "w-100",
    style = {},
}) => {
    const containerRef = useRef(null);
    const [inView, setInView] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [minDelayPassed, setMinDelayPassed] = useState(false);
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        // 🔍 Read from <html data-theme="dark"> or "light"
        const currentTheme = document.documentElement.getAttribute("data-theme");
        setIsDarkMode(currentTheme === "dark");
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                }
            },
            { threshold: 0.3 }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (inView) {
            setMinDelayPassed(false);
            const timer = setTimeout(() => setMinDelayPassed(true), 1500);
            return () => clearTimeout(timer);
        }
    }, [inView]);

    const showImage = isLoaded && minDelayPassed;

    return (
        <div
            ref={containerRef}
            className="imgskeleton"
            style={{
                position: "relative",
                height,
                overflow: "hidden",
            }}
        >
            {!showImage && (
                <div
                    style={{
                        backgroundColor: isDarkMode
                            ? "rgba(255, 255, 255, 0.08)"
                            : "rgba(15, 15, 15, 0.08)",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        zIndex: 1,
                        borderRadius: "8px",
                        transition: "opacity 0.3s ease-in-out",
                    }}
                />
            )}

            {inView && (
                <img
                    src={src}
                    alt={alt}
                    className={className}
                    onLoad={() => setIsLoaded(true)}
                    style={{
                        display: showImage ? "block" : "none",
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                        borderRadius: "8px",
                        ...style,
                    }}
                />
            )}
        </div>
    );
};

export default ImageWithSkeleton;